<template>
    <div v-if="isLoaded" class="grade">
        <empty-table-message v-if="isEmpty"/>
        <b-table
            v-else
            :data="data"
            :bordered="true"
            striped hover
            class="mt-3"
        >
            <b-table-column
                v-for="(f, i) in fields"
                :key="i"
                :field="f.key"
                :label="$t(f.key)"
                v-slot="props"
            >
                <div>
                    {{ props.row[f.key] }}
                </div>
            </b-table-column>
        </b-table>
    </div>
</template>

<script>

export default {
    props: {
        data: Array,
        isEmpty: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            fields: [],
            isLoaded: false,
        };
    },
    created() {
        this.configFields();
    },
    methods: {
        configFields() {
            const firstItem = this.data[0];

            Object.keys(firstItem).forEach(key => {
                this.fields.push({ key });
            });
            
            this.isLoaded = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.grade {
    display: flex;
    height: 100%;
}
</style>